import Header from "../../components/feature/Header";
import Footer from "../../components/feature/Footer";
import ScrollToTop from "../../components/feature/ScrollToTop";
import SEOHead from "../../components/base/SEOHead";
import HeroSection from "./components/HeroSection";
import LeagueStandings from "./components/LeagueStandings";
import ContentSection from "./components/ContentSection";

const siteUrl = import.meta.env.VITE_SITE_URL || "https://xn--9z2b23f95curk71m6qd.com";

const homeJsonLd = {
  "@context": "https://schema.org",
  "@graph": [
    {
      "@type": "WebSite",
      name: "할매티비 스포츠중계",
      url: siteUrl,
      description: "오늘 경기 스포츠중계를 무료로 실시간 시청하세요. 해외축구, MLB, NBA까지 전 경기 고화질 중계 제공.",
      inLanguage: "ko-KR",
      potentialAction: {
        "@type": "SearchAction",
        target: `${siteUrl}/sports-schedule?search={search_term_string}`,
        "query-input": "required name=search_term_string",
      },
    },
    {
      "@type": "Organization",
      name: "할매티비",
      url: siteUrl,
      description: "실시간 스포츠중계 플랫폼",
      sameAs: [siteUrl],
    },
  ],
};

export default function Home() {
  return (
    <div className="min-h-screen bg-dark-bg">
      <SEOHead
        title="스포츠중계 지금 바로 무료보기 | 오늘 경기 실시간 고화질 중계 - 할매티비"
        description="오늘 경기 스포츠중계를 무료로 실시간 시청하세요. 해외축구, MLB, NBA까지 전 경기 고화질 중계 제공, 끊김 없이 바로 접속 가능합니다. 할매티비에서 회원가입 없이 지금 바로 확인해보세요."
        keywords="스포츠중계,무료스포츠중계,실시간스포츠중계,해외축구중계,MLB중계,NBA중계,할매티비,라이브스코어,고화질중계"
        canonicalPath="/"
        jsonLd={homeJsonLd}
      />
      <Header />
      <main>
        <HeroSection />
        <LeagueStandings />
        <ContentSection />
      </main>
      <Footer />
      <ScrollToTop />
    </div>
  );
}